
<!-- Admin Dashboard Content - Bootstrap 5.3.7 Layout -->
<div class="admin-dashboard-container">
  
  <!-- Dashboard Header -->
  <div class="dashboard-header bg-white border-bottom shadow-sm mb-4 sticky-top">
    <div class="container-fluid py-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="h3 mb-0 text-gray-800">
            <i class="fa fa-tachometer-alt me-2 text-primary"></i>
            Admin Dashboard
          </h1>
          <p class="text-muted mb-0">Manage users and system settings</p>
        </div>
        <div class="form-check form-switch">
          <input 
            class="form-check-input" 
            [(ngModel)]="maintenanceMode" 
            name="isActive" 
            type="checkbox" 
            id="maintenanceToggle" 
            (click)="setMaintenanceMode()">
          <label class="form-check-label fw-semibold" for="maintenanceToggle">
            <i class="fa fa-wrench me-1"></i>
            Maintenance Mode
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Dashboard Content -->
  <div class="container-fluid pb-4">
    <form #aHomeForm="ngForm">
      
      <!-- Statistics Cards Row -->
      <div class="row g-4 mb-4">
        
        <!-- Total Users Card -->
        <div class="col-12 col-md-6 col-xl-3">
          <div class="card border-0 shadow-sm h-100 stats-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="stats-icon bg-primary bg-gradient text-white rounded-circle mb-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                    <i class="fa fa-users fa-lg"></i>
                  </div>
                  <h6 class="card-title text-primary fw-bold mb-1">Total Users</h6>
                  <p class="text-muted small mb-2">All Registered Users</p>
                  <h3 class="fw-bold text-dark mb-0">{{ this.totalUsers }}</h3>
                </div>
              </div>
              <div class="mt-3">
                <button 
                  type="button"
                  class="btn btn-outline-primary btn-sm w-100"
                  (click)="exportAllExcel(0)">
                  <i class="fa fa-download me-1"></i>
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- New Users Card -->
        <div class="col-12 col-md-6 col-xl-3">
          <div class="card border-0 shadow-sm h-100 stats-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="stats-icon bg-success bg-gradient text-white rounded-circle mb-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                    <i class="fa fa-user-plus fa-lg"></i>
                  </div>
                  <h6 class="card-title text-success fw-bold mb-1">New Users</h6>
                  <p class="text-muted small mb-2">Last 30 days</p>
                  <h3 class="fw-bold text-dark mb-0">{{ this.newUsers }}</h3>
                </div>
              </div>
              <div class="mt-3">
                <button 
                  type="button"
                  class="btn btn-outline-success btn-sm w-100"
                  (click)="exportAllExcel(30)">
                  <i class="fa fa-download me-1"></i>
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Graduated Users Card -->
        <div class="col-12 col-md-6 col-xl-3">
          <div class="card border-0 shadow-sm h-100 stats-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="stats-icon bg-warning bg-gradient text-white rounded-circle mb-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                    <i class="fa fa-graduation-cap fa-lg"></i>
                  </div>
                  <h6 class="card-title text-warning fw-bold mb-1">Graduated Users</h6>
                  <p class="text-muted small mb-2">All completed users</p>
                  <h3 class="fw-bold text-dark mb-0">{{ this.graduatedUsers }}</h3>
                </div>
              </div>
              <div class="mt-3">
                <button 
                  type="button"
                  class="btn btn-outline-warning btn-sm w-100"
                  (click)="exportCompleteExcel()">
                  <i class="fa fa-download me-1"></i>
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Inactive Users Card -->
        <div class="col-12 col-md-6 col-xl-3">
          <div class="card border-0 shadow-sm h-100 stats-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="stats-icon bg-danger bg-gradient text-white rounded-circle mb-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                    <i class="fa fa-user-times fa-lg"></i>
                  </div>
                  <h6 class="card-title text-danger fw-bold mb-1">Inactive Users</h6>
                  <p class="text-muted small mb-2">Last 14 days</p>
                  <h3 class="fw-bold text-dark mb-0">{{ this.InactiveUsers }}</h3>
                </div>
              </div>
              <div class="mt-3">
                <button 
                  type="button"
                  class="btn btn-outline-danger btn-sm w-100"
                  (click)="exportInactiveExcel()">
                  <i class="fa fa-download me-1"></i>
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Actions Section -->
      <div class="row g-4 mb-4">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-gradient bg-primary text-white">
              <h5 class="card-title mb-0">
                <i class="fa fa-bolt me-2"></i>
                Quick Actions
              </h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-6 col-md-3">
                  <a href="/backoffice/users" class="btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 text-decoration-none">
                    <i class="fa fa-users fa-2x mb-2"></i>
                    <span>Manage Users</span>
                  </a>
                </div>
                <div class="col-6 col-md-3">
                  <a href="/backoffice/classes" class="btn btn-outline-success w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 text-decoration-none">
                    <i class="fa fa-book fa-2x mb-2"></i>
                    <span>Manage Classes</span>
                  </a>
                </div>
                <div class="col-6 col-md-3">
                  <button type="button" class="btn btn-outline-info w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3">
                    <i class="fa fa-chart-bar fa-2x mb-2"></i>
                    <span>View Reports</span>
                  </button>
                </div>
                <div class="col-6 col-md-3">
                  <button type="button" class="btn btn-outline-warning w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3">
                    <i class="fa fa-cog fa-2x mb-2"></i>
                    <span>System Settings</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- System Status Row -->
      <div class="row g-4">
        <div class="col-12 col-lg-8">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-light">
              <h5 class="card-title mb-0">
                <i class="fa fa-clock me-2 text-info"></i>
                Recent Activity
              </h5>
            </div>
            <div class="card-body">
              <div class="text-center text-muted py-4">
                <i class="fa fa-chart-line fa-3x mb-3 text-muted"></i>
                <p>Activity monitoring will be displayed here</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-12 col-lg-4">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-light">
              <h5 class="card-title mb-0">
                <i class="fa fa-server me-2 text-success"></i>
                System Status
              </h5>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span>Server Status</span>
                <span class="badge bg-success">Online</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span>Database</span>
                <span class="badge bg-success">Connected</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span>Maintenance Mode</span>
                <span class="badge" [class.bg-warning]="maintenanceMode" [class.bg-success]="!maintenanceMode">
                  {{ maintenanceMode ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>

